/**
 * @generated SignedSource<<6e33d289c944fb52acd10bccfa8d5f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceSpaceSelectSearchSpacesQuery$variables = {
  query: string;
};
export type ConfluenceSpaceSelectSearchSpacesQuery$data = {
  readonly viewer: {
    readonly confluenceSpaceSearch: ReadonlyArray<{
      readonly icon: string;
      readonly key: string;
      readonly name: string;
      readonly spaceId: string;
    }>;
  };
};
export type ConfluenceSpaceSelectSearchSpacesQuery = {
  response: ConfluenceSpaceSelectSearchSpacesQuery$data;
  variables: ConfluenceSpaceSelectSearchSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "text",
      "variableName": "query"
    }
  ],
  "concreteType": "ConfluenceSpaceNode",
  "kind": "LinkedField",
  "name": "confluenceSpaceSearch",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spaceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfluenceSpaceSelectSearchSpacesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluenceSpaceSelectSearchSpacesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7ab83b668e1377b8d828acb18b1c723",
    "id": null,
    "metadata": {},
    "name": "ConfluenceSpaceSelectSearchSpacesQuery",
    "operationKind": "query",
    "text": "query ConfluenceSpaceSelectSearchSpacesQuery(\n  $query: String!\n) {\n  viewer {\n    confluenceSpaceSearch(text: $query) {\n      spaceId\n      key\n      name\n      icon\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "17aa97d0e2bb7d88a6b3bf43e9670ccc";

export default node;
